import styled from "styled-components";

import { Dialog, DialogTitle } from "@libraries/mui";

import { windowWidth } from "@styles/global";

const Container = styled(Dialog)`
  .MuiDialog-paper {
    padding: 20px !important;
    border-radius: 10px !important;
    min-width: 358px !important;

    @media (max-width: ${windowWidth.mobile.large}) {
      min-width: 95% !important;
    }
  }
`;

const Header = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px !important;
    padding-bottom: 30px !important;
    font-size: 29px !important;
  }
`;

const Title = styled.span`
  width: 65%;
  line-height: 35px;
`;

export { Container, Header, Title };
